/**
 * CmsBanner component constants
 * @namespace Component/CmsBanner/Config
 */
export const MAX_EXCERPT_LENGTH = 10;
